export class ApprovalProcessModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new ApprovalProcessModel(), obj)

    newObj.requestConfigurationMaps = obj.requestConfigurationMaps?.map(
      (item) => {
        return {
          ...item,
          projectIds: item.requestConfigurationProjects?.map(
            (item) => item?.projectId
          ),
          requestConfigurationFlows: item.requestConfigurationFlows?.map(
            (flow) => ({
              ...flow,
              requestFlowEmployees: flow.requestFlowEmployees?.map(
                (emp) => emp?.userId
              ),
            })
          ),
        }
      }
    )
    return newObj
  }

  public static assigns<T>(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
